<div class="input-group" style="width: 100%" aria-label="Select Assessment Class">
    <select name="assessmentClassSelect"
            [(ngModel)]="value"
            class="form-select form-select-sm exclude-modal-styling"
            (ngModelChange)="select($event)"
            [disabled]="isDisabled">
        @for (name of values; track name) {
            <option [ngValue]="name">{{ name }}</option>
        }
    </select>
</div>
